export default function EmptyColumn() {
  return (
    <p className="rounded-card border border-dashed border-border px-2 py-4 text-center text-xs italic text-text-dim">
      Nothing here.
    </p>
  );
}
